import { FooterMobile } from './Footer';

export default FooterMobile;
export type { FooterMobileProps } from './types';
